export default (location) => location?.urlSlug || location?.url_slug || undefined;
